import axios from 'axios';

import lstModules from 'common/json/lstModules.json';

const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
var tokenid = localStorage.getItem("tokenid");
const wingId = parseInt(localStorage.getItem('wingId')) || 0;

export const getSubjectAllocationListSvc = (syllabusId, callback) => {
    // console.log("getSubjectAllocationListSvc called, syllabusId", syllabusId);
    const formData = new FormData();
    formData.append("syllabusId", syllabusId)
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/syllabus_subject_2/list',
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in getSubjectAllocationListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstSubject = response.data.lstSubject;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;

        callback(obj);
    });
}


export const allocateTeacherSvc = (callback) => {
    // console.log("allocateTeacherSvc called, wingId", wingId);
    const formData = new FormData();
    formData.append("wingId", wingId)
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/teacher_allocation_2/allocate',
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in allocateTeacherSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;

        callback(obj);
    });
}

export const getSubjectDtlsSvc = (syllabusId, subjectId, callback) => {
    // console.log("getSubjectDtlsSvc called, syllabusId", syllabusId, ", subjectId", subjectId);
    const formData = new FormData();
    formData.append("syllabusId", syllabusId);
    formData.append("subId", subjectId);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/syllabus_subject_2/dtls',
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('data.SvcStatus=' + response.data.SvcStatus);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstGroup = response.data.lstGroup;
            obj.lstSection = response.data.lstSection;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;

        callback(obj);
    });
}


export const getFacilityListSvc = (callback) => {
    // console.log("getFacilityListSvc called");
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/mst/facility/list',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('data.SvcStatus=' + response.data.SvcStatus);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstFacility = response.data.lstFacility;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;

        callback(obj);
    });
}


export const getSyllabusListSvc = (cbSyllabusList) => {
    // console.log("getSyllabusListSvc called");
    const obj = { status: "", message: "" };
    axios({
        url: httpURL + '/sms/exam_syllabus/list',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log("response in getSyllabusListSvc", response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstSyllabus = response.data.lstSyllabus;
        }
        cbSyllabusList(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        cbSyllabusList(obj);
    })
}



export const saveSubjectAllocationSvc = (syllabusId, saveSubjectAllocationObj, callback) => {
    // console.log("saveSubjectAllocationSvc called");
    const formData = new FormData();
    formData.append("syllabusId", syllabusId);
    formData.append("subjectObj", JSON.stringify(saveSubjectAllocationObj))
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/syllabus_subject_2/save',
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('data.SvcStatus=' + response.data.SvcStatus);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;

        callback(obj);
    });
}


export const saveSubjectSharedSlotSvc = (sharedSlotObj, callback) => {
    // console.log(" saveSubjectSharedSlotSvc called");
    const formData = new FormData();
    formData.append("sharedSlotObj", JSON.stringify(sharedSlotObj))
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/syllabus_subject_2/slot_share',
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in saveSubjectSharedSlotSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;

        callback(obj);
    });
}



export const deleteSubjectSharedSlotSvc = (deleteSlotObj, callback) => {
    // console.log(" deleteSubjectSharedSlotSvc called");
    const formData = new FormData();
    formData.append("removeSharedSlotObj", JSON.stringify(deleteSlotObj))
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/syllabus_subject_2/remove_shared_slot',
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in deleteSubjectSharedSlotSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;

        callback(obj);
    });
}

export const saveSubWeeklyPeriodsSvc = (req, cb) => {
    var obj = { status: "Success" }
    var formData = new FormData();
   
    formData.append("objWeeklyPeriod", JSON.stringify(req));

    axios({
        url: httpURL + "/sms/tt/v2/syllabus_subject_2/save_weekly_period",
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true
    }).then((response) => {
        var data = response.data
        obj.status = data.SvcStatus;
        obj.message = data.SvcMsg;
        cb(obj);
    }).catch((error) => {
        // console.log("Error Occured")
        obj.status = 'Exception';
        obj.message = 'Service failed ' + error;
        cb(obj)
    });
}

export const saveBlockSizeSvc = (req, cb) => {
    var obj = { status: "Success" }
    var formData = new FormData();

    formData.append("objWeeklyPeriod", JSON.stringify(req));

    axios({
        url: httpURL + "/sms/tt/v2/syllabus_subject_2/save_block_period",
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true
    }).then((response) => {
        var data = response.data
        obj.status = data.SvcStatus;
        obj.message = data.SvcMsg;
        cb(obj);
    }).catch((error) => {
        // console.log("Error Occured")
        obj.status = 'Exception';
        obj.message = 'Service failed ' + error;
        cb(obj)
    });
}